import React, { FC } from 'react';
import { Image as AntdImage } from 'antd';
import placeholder from 'app/assets/images/redesign/placeholder.svg';

interface IComponentProps {
  size: number;
  src?: string;
}

export const Image: FC<IComponentProps> = ({ size, src }) => {
  const radius = (): number => {
    switch (true) {
      case size >= 32: {
        return 4;
      }
      case size >= 80: {
        return 8;
      }
      case size >= 168: {
        return 12;
      }
      default: {
        return 0;
      }
    }
  };

  return (
    <div>
      <div
        style={{
          margin: '0 auto',
          width: size,
          maxWidth: size,
          aspectRatio: '1 / 1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'white',
          borderRadius: radius(),
          overflow: 'hidden',
        }}
      >
        <AntdImage
          src={src ?? placeholder}
          width={size}
          height={size}
          preview={false}
          wrapperStyle={{ width: '100%', height: 'auto' }}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            borderRadius: radius(),
            objectFit: 'contain',
          }}
        />
      </div>
    </div>
  );
};
